import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/wisepim.webp';
import screenshot_target from '../../../images/letterfunnel/diegonijboer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Diego Nijboer"
      firstname="Diego"
      companyname="WISEPIM"
      competition="Plytix en Sales Layer"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/diegonijboer.js